import { useObservableState } from '@nf/utils-common/hooks';
import { sportEventModalService } from '@/services/sport-event/sport-event-modal.service';
import { Swiper, SwiperSlide } from 'swiper/react';
import { AutoPopupModal } from '@/components/widgets/modal';
import { Button } from '@nf/ui';
import { Icon } from '@/components/icons/svg-icons';
import styles from './winner-list-modal.module.scss';
import { WinnerListSlider } from '../winner-list-slider';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { AutoPopupKey } from '@nf/auto-popup-handler';

export const WinnerListModal = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const isOpen = useObservableState(sportEventModalService.winnerListModal$, false);
	const isGalaxyView = useAppearanceStore(state => state.view) === ViewEnum.galaxy;

	const handleClose = async () => {
		sportEventModalService.displayWinnerListModal(false);
	};

	return SiteConfigsData?.EnableSportEventWinnerList && isGalaxyView ? (
		<AutoPopupModal
			popupKey={AutoPopupKey.WinnerListModal}
			isOpen={isOpen}
			closeModal={handleClose}
			variant="event"
			showHeader={false}
			isBackdropClose={false}
			className={styles.modal}
		>
			<div className={styles.closeButton}>
				<Button variant="icon" onClick={handleClose}>
					<Icon name="close-round-line" />
				</Button>
			</div>
			<Swiper
				className={styles.activitySwiper}
			>
				<SwiperSlide 
					className={styles.activitySlide}
				>
					<WinnerListSlider />
				</SwiperSlide>
			</Swiper>
		</AutoPopupModal>
	) : null;
};